import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import "react-notifications/lib/notifications.css";

import { Provider } from "react-redux";
import { Store } from "./redux/Store";
import { NotificationContainer } from "react-notifications";
import { BrowserRouter } from "react-router-dom";

import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <Provider store={Store}>
        <App />
        <NotificationContainer />
      </Provider>
    </BrowserRouter>
  // </React.StrictMode>
);

console.log(process.env.NODE_ENV)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
